<template>
  <div>
    <v-autocomplete
      :items="sellers"
      v-model="value2"
      item-text="sellerDescription"
      item-value="sellerId"
      label="Filtrar Sellers"
      @change="changeSeller()"
      chips
      hide-details
      multiple
      outlined
      dense
      clearable
    >
      <template v-slot:selection="{ item, index }">
        <v-chip small v-if="index === 0" color="blue darken-1" dark>{{ item.sellerDescription }}</v-chip>
        <v-chip small color="blue-grey lighten-4" dark v-if="index === 1"> +{{ value.length - 1 }}</v-chip>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
export default {
  name: 'TheSellerSelect',
  data: () => ({
    sellerFilter: [],
    value2: null,
  }),
  props: {
    value: Array,
    sellers: Array,
    change: Function,
  },
  methods: {
    changeSeller() {
      this.$emit('input', this.value2)
    },
  },
  mounted() {
    this.value2 = this.value
  },
}
</script>

<style></style>
